import React from 'react';
import PropTypes from 'prop-types';
import UserShape from '../../shapes/user';
import { translate } from 'react-i18next';
import { classes } from './styles/table';
import AgGridReact from '../common/ag-table';

class UserTableView extends React.Component {

  onRowSelected = event => {
    const { onSelect, disabled } = this.props;
    if (!onSelect || disabled) {
      return null; // Ignore, functions aren't present to invoke
    }
    if (event.node.selected) {
      onSelect(event.data.uuid, event.data, event);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selected === this.props.selected) {
      return null;
    }
    if (!this.gridApi) {
      return null;
    }
    let { selected = [] } = this.props;
    selected = Array.isArray(selected) ? selected : [selected];
    this.gridApi.forEachNode(
      node => node.setSelected(selected.indexOf(node.data.uuid) > -1)
    );
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  render() {
    const { t, items, emptyMessage, className } = this.props;
    return (
      <div
        className={`ag-theme-blue ${classes.table} ${className || ''}`}
      >
        <AgGridReact
          name="user"
          sizeColumnsToFit
          onGridReady={this.onGridReady}
          ref={this.onReference}
          onRowSelected={this.onRowSelected}
          rowSelection="single"
          enableFilter
          enableSorting
          columnDefs={[
            {
              field: 'activeFormatted',
              headerName: t('table.activeHeader')
            },
            {
              field: 'userName',
              headerName: t('table.userNameHeader')
            },
            {
              field: 'firstName',
              headerName: t('table.firstNameHeader')
            },
            {
              field: 'lastName',
              headerName: t('table.lastNameHeader')
            }
          ]}
          items={
            items
              .map(
                item => ({
                  ...item,
                  activeFormatted: (item.active || 'false').toString()
                })
              )
          }
          localeText={{
            noRowsToShow: emptyMessage || t('table.emptyMessage')
          }}
        />
      </div>
    );
  }

}

UserTableView.propTypes = {
  items: PropTypes.arrayOf(
    UserShape.isRequired
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.string.isRequired
    )
  ]),
  emptyMessage: PropTypes.string,
  disabled: PropTypes.bool,
  filter: PropTypes.string,
  className: PropTypes.string
};

export default translate(['user'])(UserTableView);



// WEBPACK FOOTER //
// ./src/views/user/table.js